export default "__VITE_ASSET__E4HSwig2__"